import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };

  return (
    <div className="language-switcher">
      <span className="language-label">{t('app.language')}:</span>
      <div className="language-buttons">
        <button
          className={`language-button ${i18n.language === 'ja' ? 'active' : ''}`}
          onClick={() => handleLanguageChange('ja')}
        >
          日本語
        </button>
        <button
          className={`language-button ${i18n.language === 'en' ? 'active' : ''}`}
          onClick={() => handleLanguageChange('en')}
        >
          English
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;